import React from 'react'
import parse from 'html-react-parser'

import { Download } from '../icons'
import PopupModal from '../popup-modal'
import ActiveCampaignForm from '../active-campaign-form'

const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

const niceBytes = (x) => {

  let l = 0, n = parseInt(x, 10) || 0;

  while (n >= 1024 && ++l) {
    n = n / 1024;
  }

  return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
}

const ResourceStrip = ({ title = '', acf = null, color, brochureFormId = 329, brochureFormText = '' }) => {

  const [popup, setPopup] = React.useState(false)

  //  href={acf.file?.localFile?.publicURL} download

  return (
    <>
      <a className='resource-strip' href='#download' onClick={(e) => {
        e.preventDefault()
        
        // check if cookie exists
        const cookie = document.cookie.split(';').find(c => c.includes('resource_form=true'))
        if (cookie) {
          window.open(acf.file?.localFile?.publicURL, '_blank')
          return
        }
        setPopup(true)
      }}>
        <Download color={color} />
        <h4>{parse(title)}</h4>
        <div className='resource-strip__size'>
          <span>{acf.file?.localFile?.extension}</span>
          <span>{niceBytes(acf.file?.localFile?.size)}</span>
        </div>
      </a>

      <PopupModal active={popup} onClose={() => setPopup(false)}>
        { parse(brochureFormText) }
        {popup && <ActiveCampaignForm formId={brochureFormId} onComplete={() => {
          setPopup(false)
          // open file download in new tab
          window.open(acf.file?.localFile?.publicURL, '_blank')
          // set cookie to prevent popup from showing again
          document.cookie = `resource_form=true; expires=Fri, 31 Dec 9999 23:59:59 GMT`

        }} resource_name={title} />}
      </PopupModal>
    </>
  )
}

export default ResourceStrip